import TYPES from "../../types"
import COMMON from "../../fragments/common"
import { mergeQueriesArray } from "@repo/utils"

const STORY_MODULE_FRAGMENT = `
	...on ${TYPES.STORY_MODULE} {
        id
        step0Header
        step0StartButtonText
        step0BlockedDailyText
        step0BlockedMonthlyText
        step1Description
        step1NextButtonText
        step1BackButtonText
        step2Description
        step2BackButtonText
        step2GenerateButtonText
        step3LoadingText
        step4SummaryText
        step4ResetButtonText
        step4ContactUsButtonText
        step4FallbackStoryTitle
        step4ShareHeader
        step4ShareSocials{
            social: socialType
        }
        step4DiscoverModalHeader
        step4DiscoverModalDescription
        step4DiscoverModalLeftButtonText
        step4DiscoverModalRightButtonText
        ${COMMON.PADDINGS_FRAGMENT}
    }
`

const VIDEO_BANNER_FRAGMENT = `
    ...on ${TYPES.VIDEO_BANNER} {
        id
        video
		banner {
			variant
			text {
				${COMMON.TEXT_WITH_BREAKS_FRAGMENT}  
			}
		}
		withDescription
		description {
			description
			side
        	${COMMON.PADDINGS_FRAGMENT}
		}
    }
`

const FORM_MODULE_FRAGMENT = `
    ... on ${TYPES.FORM} {
        id
        headerText
        ${COMMON.PADDINGS_FRAGMENT}
        topBarImage {
            ${COMMON.IMAGE_FRAGMENT}
        }
        stepOneHeader
        stepOneOptions {
            id
            text
            value
            color {
                cssRgb
            }
        }
        stepTwoHeader
        stepTwoOptions {
            id
            name
            placeholder
            required
            inputType
            errorText
        }
        stepThreeHeader
        stepThreeOptions {
            id
            text
            value
            color {
                cssRgb
            }
        }
        termsText
        termsShowMoreText
        termsRestOfText
        modalHeader
        modalText
        modalButtonText
        buttonText
        carouselText
    }
`

const PLEO_BRANCHES_MODULE_FRAGMENT = `
    ... on ${TYPES.PLEO_BRANCHES} {
        id
        title
        redirectButtonText
        ${COMMON.COLOR_SCHEME_FRAGMENT}
        items {
            id
            link
            subheader
            description
            backgroundColor {
                hex
            }
            logoImage {
               ${COMMON.IMAGE_FRAGMENT}
            }
        }
    }
`

const DESCRIPTION_AND_SLOGAN_MODULE_FRAGMENT = `
    ...on ${TYPES.DESCRIPTION_SLOGAN} {
        id
        description
        side
        paddings: padding{
          top
          bottom
        }
        ${COMMON.COLOR_SCHEME_FRAGMENT}
    }
`

const HOW_WE_WORK_MODULE_FRAGMENT = `
    ...on ${TYPES.HOW_WE_WORK_MODULE} {
        id
        header
        endHeader
        steps{
          id
          header
          description
        }
        cards {
          id
          icon {
            ${COMMON.IMAGE_FRAGMENT}
          }
          header
          description
        }
        ${COMMON.PADDINGS_FRAGMENT}
        ${COMMON.COLOR_SCHEME_FRAGMENT}
    }
`

const HORIZONTAL_HEADER_MODULE_FRAGMENT = `
    ... on ${TYPES.HORIZONTAL_HEADER} {
        id
        title
        text
        transparentBackground
        direction
        ${COMMON.PADDINGS_FRAGMENT}
        ${COMMON.COLOR_SCHEME_FRAGMENT}
    }
`
const HEADER_DESCRIPTION_BUTTON_BANNER_RECORD_FRAGMENT = `
    ... on ${TYPES.HEADER_DESCRIPTION_BUTTON_BANNER_RECORD} {
        id
        header
        description
        ${COMMON.COLOR_SCHEME_FRAGMENT}
        buttonText
    }
`

const TECHNOLOGIES_TILES_FRAGMENT = `
    ... on ${TYPES.TECHNOLOGIES_TILES} {
        id
        title
        ${COMMON.PADDINGS_FRAGMENT}
        ${COMMON.COLOR_SCHEME_FRAGMENT}
        technologies {
            id
            name: projectTechnologyName
            slug
            icon {
               ${COMMON.IMAGE_FRAGMENT}
            }
        }
    }
`
const NUMBERS_RECORD_FRAGMENT = `
    ... on ${TYPES.NUMBERS_RECORD} {
        id
        heading
        ${COMMON.PADDINGS_FRAGMENT}
        ${COMMON.COLOR_SCHEME_FRAGMENT}
        numbers {
            id
            title
            number
            description
        }
    }
`

const CHECK_OTHER_SERVICES_FRAGMENT = `
    ... on ${TYPES.CHECK_OTHER_SERVICES} {
        id
        ${COMMON.PADDINGS_FRAGMENT}
        chooseSeeAlsoBlocks {
            title
            hoverDescription
            chooseLinkPage {
                __typename
                ... on ${TYPES.PAGES.SERVICE_PAGE_RECORD} {
                    slug
                    card {
                        icon {
                            ${COMMON.IMAGE_FRAGMENT}
                        }
                    }
                }
                ... on ${TYPES.PAGES.COMPETENCES_PAGE_RECORD} {
                    slug
                    card {
                        icon {
                            ${COMMON.IMAGE_FRAGMENT}
                        }
                    }
                }
                ... on ${TYPES.PAGES.PROJECT_TECHNOLOGY_RECORD} {
                    slug
                    icon {
                        ${COMMON.IMAGE_FRAGMENT}
                    }
                }
            }
        }
    }  
`

const PLEO_CONTEXT_MODULE_FRAGMENT = `
    ... on ${TYPES.PLEO_CONTEXT} {
        id
        largeText
        sectionHeader
        image {
            ${COMMON.IMAGE_FRAGMENT}
        }
        video {
             ${COMMON.VIDEO_FRAGMENT}
        }
        fullScreenVideo{
          link{
            url
          }
        }
        whoWeAreBlocks {
            id
            title
            textFirstPart
            textSecondPart
            description
            image {
                ${COMMON.IMAGE_FRAGMENT}
            }
        }
        numbersSlides: slides{
          id
          number
          caption
          description
        }
        valuesCards{
          id
          icon{
            ${COMMON.IMAGE_FRAGMENT}
          }
          header
          description
        }
    }
`

const TEXT_MODULE_FRAGMENT = `
    ... on ${TYPES.TEXT_MODULE} {
        id
        chooseTextModuleVariants {
            __typename
            ... on ${TYPES.QUOTE_BLOCK} {
                quote
                author
                id
                ${COMMON.PADDINGS_FRAGMENT}
                ${COMMON.COLOR_SCHEME_FRAGMENT}
            }
            ... on ${TYPES.TEXT_CENTERED_BLOCK} {
                text
                id
                ${COMMON.PADDINGS_FRAGMENT}
                ${COMMON.COLOR_SCHEME_FRAGMENT}
            }
            ... on ${TYPES.HEADER_DESCRIPTION_TWO_COLUMNS_BLOCK} {
                header
                description
                id
                ${COMMON.PADDINGS_FRAGMENT}
                ${COMMON.COLOR_SCHEME_FRAGMENT}
            }
            ... on ${TYPES.HEADER_DESCRIPTION_HALF_WIDTH_BLOCK} {
                header
                description
                id
                alignToRight
                ${COMMON.PADDINGS_FRAGMENT}
                ${COMMON.COLOR_SCHEME_FRAGMENT}
            }
            ... on ${TYPES.TEXT_BREAK} {
                id
                text
                ${COMMON.COLOR_SCHEME_FRAGMENT}
                ${COMMON.PADDINGS_FRAGMENT}
                breaks {
                    ... on ${TYPES.IMAGE_BREAK} {
                        image {
                            ${COMMON.IMAGE_FRAGMENT}
                        }
                    }
                }
            }
            ... on ${TYPES.TYPOGRAPHY_BIG} {
                text
                ${COMMON.PADDINGS_FRAGMENT}
                ${COMMON.COLOR_SCHEME_FRAGMENT}
            }
            ... on ${TYPES.TYPOGRAPHY_MEDIUM_TEXT} {
                id
                text
                align
               ${COMMON.PADDINGS_FRAGMENT}
               ${COMMON.COLOR_SCHEME_FRAGMENT}
            }
        }
    }
`

const QUICK_CONTACT_MODULE_FRAGMENT = `
    ... on ${TYPES.QUICK_CONTACT} {
        id
        header
        phoneNumber
        email
        image {
            ${COMMON.IMAGE_FRAGMENT}
        }
        ${COMMON.PADDINGS_FRAGMENT}
        ${COMMON.COLOR_SCHEME_FRAGMENT}
    }
`

const FILTERS_FRAGMENT = `
    filters {
        ... on ${TYPES.PROJECT_CATEGORY} {
            projectCategory
            projectCategoryId
        }
    }
`

const PRODUCTS_GRID_FRAGMENT = `
    ... on ${TYPES.PRODUCTS_GRID} {
        productsGridItems {
            __typename
            ... on ${TYPES.PRODUCTS_ONE_IN_ROW} {
                id
                chooseProduct {
                    productName
                    client
                    coverImage {
                       ${COMMON.IMAGE_FRAGMENT}
                    }
                }
            }
            ... on ${TYPES.PRODUCTS_TWO_IN_ROW} {
                id
                chooseProduct {
                    productName
                    client
                    coverImage {
                        ${COMMON.IMAGE_FRAGMENT}
                    }
                }
            }
            ... on ${TYPES.PRODUCTS_THREE_IN_ROW} {
                id
                chooseProduct {
                    productName
                    client
                    coverImage {
                        ${COMMON.IMAGE_FRAGMENT}
                    }
                }
            }
        }
    }
`

const CLIENTS_ABOUT_US_RECORD_FRAGMENT = `
    ... on ${TYPES.CLIENTS_ABOUT_US_RECORD} {
        id
        ${COMMON.COLOR_SCHEME_FRAGMENT}
        ${COMMON.PADDINGS_FRAGMENT}
        header
        buttonText
        clients {
            id
            text
            author
            textColor {
                cssRgb
            }
            project {
                ... on DesignSingleProjectRecord {
                    id
                    slug
                    projectColor {
                        cssRgb
                    }
                    coverPortrait {
                        ${COMMON.IMAGE_FRAGMENT}
                    }
                    video {
                        ${COMMON.VIDEO_FRAGMENT}
                    }
                }
                ... on DigitalSingleProjectRecord {
                    id
                    slug
                    projectColor {
                        cssRgb
                    }
                    coverPortrait {
                        ${COMMON.IMAGE_FRAGMENT}
                    }
                    video {
                        ${COMMON.VIDEO_FRAGMENT}
                    }
                }
            }
            asset {
                url
                alt
                width
                height
                mimeType
            }
        }
    }
`

const PROJECTS_TABLE_FRAGMENT = `
    projectsTable {
        id
        buttonText
        header
        headers {
            text
        }
        ${COMMON.PADDINGS_FRAGMENT}
        loadMoreButtonText
        showLoadMoreButton
        items {
            title
            client
            industry
            year
            externalUrl
            chooseProject {
              __typename
              ... on DigitalSingleProjectRecord{
                name
                slug
              }
              ... on DesignSingleProjectRecord{
                name
                slug
              }
            }
            cursorAsset {
                id
                width
                height
                url
                alt
                mimeType
            }
            shouldOpenInNewTab
            servicesAndCompetences {
                __typename
                ... on ${TYPES.PAGES.COMPETENCES_PAGE_RECORD} {
                    id          
                    name: competenceName
                    slug
                }
                ... on ${TYPES.PAGES.SERVICE_PAGE_RECORD} {
                    id
                    name: serviceName
                    slug
                }
            }
            technologiesAndTools {
                __typename
                ... on ${TYPES.PAGES.PROJECT_TECHNOLOGY_RECORD} {
                    id
                    name: projectTechnologyName
                    slug
                }
            }
        }
    }
`

const WHO_WE_WORKED_WITH_MODULE_FRAGMENT = `
    ... on ${TYPES.WHO_WE_WORKED_WITH} {
        id
        header
        description
        bottomText
        video {
            url
            alt
        }
        items {
            id
            text
        }
        ${COMMON.PADDINGS_FRAGMENT}
        ${COMMON.COLOR_SCHEME_FRAGMENT}
    }
`

const PROJECT_SLIDER_FRAGMENT = `
    ... on ${TYPES.PROJECT_SLIDER} {
        id
        title
        slides {
            ${COMMON.IMAGE_FRAGMENT}
        }
        ${COMMON.PADDINGS_FRAGMENT}
        ${COMMON.COLOR_SCHEME_FRAGMENT}
    }
`

const TECHNOLOGIES_TABLE_FRAGMENT = `
    ... on ${TYPES.TECHNOLOGIES_TABLE} {
        id
        title
        text
        textRight
        technologiesText
        video {
            url
            alt
        }
        ${COMMON.PADDINGS_FRAGMENT}
        ${COMMON.COLOR_SCHEME_FRAGMENT}
    }
`

const PROJECT_SCOPE_FRAGMENT = `
    ... on ${TYPES.PROJECT_SCOPE} {
        id
        title
        stages {
          id
          name
          description
          image {
            image {
              ${COMMON.IMAGE_FRAGMENT}
            }
          }
        }
        ${COMMON.PADDINGS_FRAGMENT}
        ${COMMON.COLOR_SCHEME_FRAGMENT}
    }
`

const ASSETS_GALLERY_FRAGMENT = `
    ... on ${TYPES.ASSETS_GALLERY} {
        id
        galleryName
        ${COMMON.PADDINGS_FRAGMENT}
        ${COMMON.COLOR_SCHEME_FRAGMENT}
        assets {
            url
            mimeType
            id
            width
            height
        }
    }
`

const ASSET_WITH_HEADER_FRAGMENT = `
    ... on ${TYPES.ASSET_WITH_HEADER} {
        id
        header
        description
        asset {
            url
            width
            height
            mimeType
            focalPoint {
                x
                y
            }
        }
        imageVariant
        ${COMMON.PADDINGS_FRAGMENT}
        ${COMMON.COLOR_SCHEME_FRAGMENT}
    }
`

const PROJECT_SECTION_HEADER_FRAGMENT = `
    ... on ${TYPES.PROJECT_SECTION_HEADER} {
        id
        title
        text
        anchor
        id
        ${COMMON.PADDINGS_FRAGMENT}
        ${COMMON.COLOR_SCHEME_FRAGMENT}
    }
`

const PADDING_MODULE_FRAGMENT = `
    ... on PaddingRecord {
        size
    }
`

const PROJECT_RANGE_FRAGMENT = `
    ... on ${TYPES.PROJECT_RANGE} {
        id
        title
        projectShortDescription
        projectDescription
        carouselText
        client {
            clientName
        }
        industry {
            industryName
        }
        serviceRange {
            __typename
            ... on ${TYPES.PAGES.COMPETENCES_PAGE_RECORD} {
                id          
                competenceName
                slug
            }
            ... on ${TYPES.PAGES.SERVICE_PAGE_RECORD} {
                id
                serviceName
                slug
            }
        }
        technologies {
            projectTechnologyName
            slug
        }
       competences {
          competenceName
          slug
        }
        tools {
            projectTechnologyName
            slug
        }
        cooperation
        year
        year2
        link {
            buttonText
            variant
            url
        }
        ${COMMON.PADDINGS_FRAGMENT}
        ${COMMON.COLOR_SCHEME_FRAGMENT}
    }
`

const PINNED_TEXT_WITH_IMAGE_FRAGMENT = `
    ... on ${TYPES.PINNED_TEXT_WITH_IMAGE} {
        id
        header
        description
        noPin
        imagetoedge
        image {
           ${COMMON.IMAGE_FRAGMENT}
        }
        videoUrl {
          url
          width
          height
        }
        ${COMMON.PADDINGS_FRAGMENT}
        ${COMMON.COLOR_SCHEME_FRAGMENT}
        imageOnRightSide
    }
`

const SOCIAL_MEDIA_FRAGMENT = `
    ... on ${TYPES.SOCIAL_MEDIA} {
        id
        ${COMMON.PADDINGS_FRAGMENT}
        ${COMMON.COLOR_SCHEME_FRAGMENT}
        socialMedia {
            title
            link
        }
    }
`

const SINGLE_ASSET_FRAGMENT = `
    ... on ${TYPES.SINGLE_ASSET} {
        id
        title
        ${COMMON.COLOR_SCHEME_FRAGMENT}
        ${COMMON.PADDINGS_FRAGMENT}
        externalVideoUrl {
            url
            width
            height
        }
        asset {
            url
            mimeType
            id
            width
            height
        }
        carouselText
        animation3d
        assetVariant
        animationExpandOnScroll
        backgroundColor {
          hex
        }
        fullScreenVideo{
          link{
            url
          }
        }
    }
`

const HEADER_AND_DESCRIPTION_FRAGMENT = `
    ... on ${TYPES.HEADER_AND_DESCRIPTION} {
        id
        header
        description
        ${COMMON.PADDINGS_FRAGMENT}
        ${COMMON.COLOR_SCHEME_FRAGMENT}
    }
`

const SERVICES_LINK_QUERY = `
    ... on ${TYPES.PAGES.SERVICE_PAGE_RECORD} {
        slug
    }
`

const SERVICES_CARDS_MODULE_FRAGMENT = `
    ... on ${TYPES.SERVICES_CARDS} {
        id
        title
        buttonText
        ${COMMON.PADDINGS_FRAGMENT}
        ${COMMON.COLOR_SCHEME_FRAGMENT}
        items {
            id
            video{
                url
                alt
                width
                height
            }
            servicePage {
                id
                card {
                    id
                    header
                    description
                    ${COMMON.LINK_BUTTON_FRAGMENT_FUNCTION([SERVICES_LINK_QUERY])}
                    icon {
                       ${COMMON.IMAGE_FRAGMENT}
                    }
                }
            }
        }
    }
`

const AREA_OF_EXPERTISE_MODULE_FRAGMENT = `
    ... on ${TYPES.AREAS_OF_EXPERTISE}	{
        heading
        chooseServices {
            serviceName
            serviceDescription
            slug
            pleoType
            chooseCompetences{
                competenceName
                slug
                disableCompetence
            }
            areaColorBackground {
                hex
            }
            borderColor {
                hex
            }
            videoFile {
                url
                width
                height
                alt
            }
            externalVideoUrl {
                url
                width
                height
            }
        }
        rangePlaceholder
        buttonText
    }
`

const CARRER_MODULE_FRAGMENT = `
    ... on ${TYPES.CAREER_MODULE} {
        id
        header
        description
        ${COMMON.PADDINGS_FRAGMENT}
        ${COMMON.COLOR_SCHEME_FRAGMENT}
        jobOffers {
            id
            slug
            card {
                header
                level
                description
                buttonText
            }
        }
    }
`

const BENEFITS_MODULE_FRAGMENT = `
    ... on ${TYPES.BENEFITS_MODULE} {
        id
        header
        ${COMMON.PADDINGS_FRAGMENT}
        ${COMMON.COLOR_SCHEME_FRAGMENT}
        benefits {
            id
            title
            text
        }
    }
`

const JOB_OFFER_FORM_MODULE_FRAGMENT = `
    ... on ${TYPES.JOB_OFFER_FORM} {
        id
        inputs {
            id
            name
            placeholder
            required
            inputType
            errorText
        }
        attachFileText
        buttonText
        termsText
        termsShowMoreText
        termsRestOfText
        modalHeader
        modalText
        modalButtonText
        ${COMMON.PADDINGS_FRAGMENT}
        ${COMMON.COLOR_SCHEME_FRAGMENT}
    }
`

const CHECK_OTHERS_MODULE_FRAGMENT_FUNCTION = (links = [""]) => {
	const linksQuery = mergeQueriesArray(links)
	return `
        ... on ${TYPES.CHECK_OTHERS} {
            id
            contactHeader
            checkOthersHeader
            isColorfulBackground
            text {
              ${COMMON.TEXT_WITH_BREAKS_FRAGMENT}
            }
            links {
              ${linksQuery}
            }
        }	
    `
}

const BREADCRUMBS_FRAGMENT_FUNCTION = (links = [""]) => {
	return `
        breadcrumbs {
            id
            text
            ${COMMON.LINK_FRAGMENT_FUNCTION(links)}
        }	
    `
}

const STICKY_HEADING_FRAGMENT_FUNCTION = (modules = [""]) => {
	const extraModulesQuery = mergeQueriesArray(modules)
	return `
        stickyHeadingsSelector {
            ... on ${TYPES.STICKY_HEADING} {
                module {
                    __typename
                    ... on ${TYPES.NEWS_THUMBNAILS} {
                        id
                    }
                    ... on ${TYPES.DESCRIPTION_SLOGAN} {
                        id
                    }
                    ... on ${TYPES.TEXT_MODULE} {
                        id
                    }
                    ... on ${TYPES.DESCRIPTION_LOGO_PLEO} {
                        id
                    }
                    ... on ${TYPES.HOW_WE_CREATE_STORY} {
                        id
                    }
                    ... on ${TYPES.COMMON_BLOB_SLOGAN} {
                        id
                    }
                    ... on ${TYPES.FEATURED_PROJECTS} {
                        id
                    }
                    ... on ${TYPES.WHO_WE_WORKED_WITH} {
                        id
                    }
                    ... on ${TYPES.PLEO_CONTEXT} {
                        id
                    }
                    ... on ${TYPES.CAREER_MODULE} {
                        id
                    }
                    ... on ${TYPES.CLIENTS_ABOUT_US_RECORD} {
                        id
                    }
                    ... on ${TYPES.FORM} {
                        id
                    }
                    ... on ${TYPES.PLEO_BRANCHES} {
                        id
                    }
                    ... on ${TYPES.CHECK_OTHERS} {
                        id
                    }
                    ... on ${TYPES.HORIZONTAL_HEADER}{
                        id
                    }						
                    ... on ${TYPES.QUICK_CONTACT} {
                        id
                    }
                    ... on ${TYPES.TILES_WITH_DESCRIPTION} {
                        id
                    }
                    ... on ${TYPES.SERVICES_CARDS} {
                        id 
                    }
                    ... on ${TYPES.TILES_MODULE} {
                        id
                    }
                    ... on ${TYPES.TECHNOLOGIES_TILES} {
                        id
                    }
                    ... on ${TYPES.NUMBERS_RECORD} {
                        id
                    }
                    ... on ${TYPES.PROJECTS_GRID} {
                        id
                    }
                    ... on ${TYPES.CHECK_OTHER_SERVICES} {
                        id
                    }
                    ... on ${TYPES.BENEFITS_MODULE} {
                        id
                    }
                    ${extraModulesQuery}
                }
                headingText
            }
        }
    `
}

const TILES_MODULE_FRAGMENT_FUNCTION = (links = [""]) => {
	return `
        ... on ${TYPES.TILES_MODULE} {
            id
            header
            ${COMMON.LINK_BUTTON_FRAGMENT_FUNCTION(links)}
            isProjectPage
            ${COMMON.COLOR_SCHEME_FRAGMENT}
            ${COMMON.PADDINGS_FRAGMENT}
            items{
              __typename
              ... on ${TYPES.PAGES.COMPETENCES_PAGE_RECORD} {
                id
                slug
                pleoType
                card{
                  id
                  header
                  description
                  soonMask
                  icon{
                    ${COMMON.IMAGE_FRAGMENT}
                  }
                }
              }
            }
        }
    `
}

const TILES_WITH_DESCRIPTION_FRAGMENT_FUNCTION = (links = [""]) => {
	const linksQuery = mergeQueriesArray(links)
	return `
        ... on ${TYPES.TILES_WITH_DESCRIPTION} {
            id
            title
            buttonText
            ${COMMON.PADDINGS_FRAGMENT}
            ${COMMON.COLOR_SCHEME_FRAGMENT}
            items {
                id
                header
                description
                image {
                    ${COMMON.IMAGE_FRAGMENT}
                }
                buttonLink {
                    __typename
                    ${linksQuery}
                }
            }
        }
    `
}

const BLOB_SLOGAN_FRAGMENT_FUNCTION = (links = [""]) => {
	return `
        ... on ${TYPES.COMMON_BLOB_SLOGAN} {
            id
            slogans{
              id
              text
              align
            }
            ${COMMON.PADDINGS_FRAGMENT}
            servicesPages{
                id
                card {
                    header
                    description
                    icon{
                        ${COMMON.IMAGE_FRAGMENT}
                    }
                    ${COMMON.LINK_BUTTON_FRAGMENT_FUNCTION(links)}
                }
            }
        }
    `
}

const DESCRIPTION_LOGO_PLEO_FRAGMENT_FUNCTION = (links = [""]) => {
	return `
        ... on ${TYPES.DESCRIPTION_LOGO_PLEO} {
            id
            header
            description
            ${COMMON.LINK_BUTTON_FRAGMENT_FUNCTION(links)}
            ${COMMON.PADDINGS_FRAGMENT}
        }
    `
}

const FEATURED_PROJECTS_FRAGMENT_FUNCTION = (links = [""], grid = [""]) => {
	const gridQuery = mergeQueriesArray(grid)
	return `
        ... on ${TYPES.FEATURED_PROJECTS} {
            id
            text
            scaleXAxisVariant
            ${COMMON.PADDINGS_FRAGMENT}
            ${COMMON.LINK_BUTTON_FRAGMENT_FUNCTION(links)}
            projects {
                id
                __typename
                indent
                grid {
                    ${gridQuery}
                }
            }
        }
    `
}

const HOW_WE_CREATE_STORY_FRAGMENT_FUNCTION = (buttonLinks = [""], links = [""]) => {
	const linksQuery = mergeQueriesArray(links)
	return `
    ... on ${TYPES.HOW_WE_CREATE_STORY} {
        id
        slogan
        ${COMMON.PADDINGS_FRAGMENT}
        ${COMMON.LINK_BUTTON_FRAGMENT_FUNCTION(buttonLinks)}
        items {
            id
            tag
            text
            slug {
               ${linksQuery}
            }
            image {
                ${COMMON.IMAGE_FRAGMENT}
            }
            hoverImage {
                ${COMMON.IMAGE_FRAGMENT}
            }
        }
    }
`
}

const NEWS_THUMBNAILS_FRAGMENT_FUNCTION = (buttonLinks = [""]) => {
	return `
        ... on ${TYPES.NEWS_THUMBNAILS} {
            id
            header
            displayGridLines
            gridLinesEndModule {
                ... on ${TYPES.HOW_WE_CREATE_STORY} {
                    id
                }
            }
            ${COMMON.LINK_BUTTON_FRAGMENT_FUNCTION(buttonLinks)}
            chooseNews {
                __typename
                blogPageName
                slug
                wordsCount
                _createdAt
                ${COMMON.THEME_FRAGMENT}
                pleoCategory
                categories
                thumbnailImage {
                    ${COMMON.IMAGE_FRAGMENT}
                }
            }
            ${COMMON.PADDINGS_FRAGMENT}
        }
`
}

const PROJECTS_GRID_FRAGMENT_FUNCTION = (grid = [""]) => {
	const gridQuery = mergeQueriesArray(grid)
	return `
        ... on ${TYPES.PROJECTS_GRID} {
            __typename
            id
            indent
            grid {
                ... on ${TYPES.TEXT_SMALL_IMAGE} {
                    id
                    text
                    asset{
                      asset {
                        ${COMMON.IMAGE_FRAGMENT}
                      }
                    }
                }
                ... on ${TYPES.TEXT_WITH_BREAK} {
                    ${COMMON.TEXT_WITH_BREAKS_FRAGMENT}
                }
                ${gridQuery}
            }
        }
`
}

const FAQ_FRAGMENT = `
    ... on ${TYPES.FAQ} {
        id
        header {
            text
            breaks {
                id
                image {
                    ${COMMON.IMAGE_FRAGMENT}
                }
            }
        }
        text{
            ${COMMON.TEXT_WITH_BREAKS_FRAGMENT}
        }
        ${COMMON.COLOR_SCHEME_FRAGMENT}
        ${COMMON.PADDINGS_FRAGMENT}
        questions {
            question
            answer
        }
    }
`

const ABOUT_TEAM_FRAGMENT = `
    ... on ${TYPES.ABOUT_TEAM} {
        id
        title
        tagText
        leftText
        boldText
        expandCardButtonText
        collapseCardButtonText
        cards {
            id
            title
            name
            jobTitle
            pictogram {
                ${COMMON.IMAGE_FRAGMENT}
            }
            video {
                url
                alt
            }
            aboutTeamSingleCardItems {
                id
                text
                image {
                    ${COMMON.IMAGE_FRAGMENT}
                }
            }
        }
    }
`

const COMPONENTS = Object.freeze({
	STORY_MODULE_FRAGMENT,
	VIDEO_BANNER_FRAGMENT,
	FORM_MODULE_FRAGMENT,
	PLEO_BRANCHES_MODULE_FRAGMENT,
	DESCRIPTION_AND_SLOGAN_MODULE_FRAGMENT,
	HOW_WE_WORK_MODULE_FRAGMENT,
	HORIZONTAL_HEADER_MODULE_FRAGMENT,
	PLEO_CONTEXT_MODULE_FRAGMENT,
	TEXT_MODULE_FRAGMENT,
	QUICK_CONTACT_MODULE_FRAGMENT,
	WHO_WE_WORKED_WITH_MODULE_FRAGMENT,
	SERVICES_CARDS_MODULE_FRAGMENT,
	AREA_OF_EXPERTISE_MODULE_FRAGMENT,
	CARRER_MODULE_FRAGMENT,
	BENEFITS_MODULE_FRAGMENT,
	JOB_OFFER_FORM_MODULE_FRAGMENT,
	HEADER_DESCRIPTION_BUTTON_BANNER_RECORD_FRAGMENT,
	CHECK_OTHER_SERVICES_FRAGMENT,
	TECHNOLOGIES_TILES_FRAGMENT,
	NUMBERS_RECORD_FRAGMENT,
	FILTERS_FRAGMENT,
	PRODUCTS_GRID_FRAGMENT,
	CLIENTS_ABOUT_US_RECORD_FRAGMENT,
	PROJECTS_TABLE_FRAGMENT,
	PROJECT_SLIDER_FRAGMENT,
	TECHNOLOGIES_TABLE_FRAGMENT,
	PROJECT_SCOPE_FRAGMENT,
	ASSETS_GALLERY_FRAGMENT,
	ASSET_WITH_HEADER_FRAGMENT,
	PROJECT_SECTION_HEADER_FRAGMENT,
	PADDING_MODULE_FRAGMENT,
	PROJECT_RANGE_FRAGMENT,
	PINNED_TEXT_WITH_IMAGE_FRAGMENT,
	SOCIAL_MEDIA_FRAGMENT,
	FAQ_FRAGMENT,
	ABOUT_TEAM_FRAGMENT,
	SINGLE_ASSET_FRAGMENT,
	HEADER_AND_DESCRIPTION_FRAGMENT,
	CHECK_OTHERS_MODULE_FRAGMENT_FUNCTION,
	BREADCRUMBS_FRAGMENT_FUNCTION,
	STICKY_HEADING_FRAGMENT_FUNCTION,
	TILES_MODULE_FRAGMENT_FUNCTION,
	TILES_WITH_DESCRIPTION_FRAGMENT_FUNCTION,
	BLOB_SLOGAN_FRAGMENT_FUNCTION,
	DESCRIPTION_LOGO_PLEO_FRAGMENT_FUNCTION,
	FEATURED_PROJECTS_FRAGMENT_FUNCTION,
	HOW_WE_CREATE_STORY_FRAGMENT_FUNCTION,
	NEWS_THUMBNAILS_FRAGMENT_FUNCTION,
	PROJECTS_GRID_FRAGMENT_FUNCTION,
})

export default COMPONENTS
